"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { useState, useEffect } from "react";
import { isEqual } from "lodash";
import { addFilterValue, removeFilterValue } from "./filterUtils";
export const useFilterState = ({ filters, isOpen }) => {
  const [localFilters, setLocalFilters] = useState(filters);
  const [newValues, setNewValues] = useState({});
  const [hasChanges, setHasChanges] = useState(false);
  useEffect(() => {
    if (isOpen) {
      setLocalFilters(filters);
      setNewValues({});
      setHasChanges(false);
    }
  }, [isOpen, filters]);
  useEffect(() => {
    const hasChangesMade = isEqual(localFilters, filters);
    setHasChanges(!hasChangesMade);
  }, [localFilters, filters]);
  const handleAddFilter = (key, value) => {
    if (!value.trim()) return;
    const updatedFilters = addFilterValue(localFilters, key, value);
    setLocalFilters(updatedFilters);
    setNewValues(__spreadProps(__spreadValues({}, newValues), { [key]: "" }));
  };
  const handleRemoveFilter = (key, index, subIndex) => {
    const updatedFilters = removeFilterValue(localFilters, key, index, subIndex);
    setLocalFilters(updatedFilters);
  };
  const handleValueChange = (key, value) => {
    setNewValues(__spreadProps(__spreadValues({}, newValues), { [key]: value }));
  };
  const resetState = () => {
    setLocalFilters(filters);
    setNewValues({});
  };
  return {
    localFilters,
    newValues,
    hasChanges,
    handleAddFilter,
    handleRemoveFilter,
    handleValueChange,
    resetState
  };
};
